import { Injectable } from '@angular/core';
import { CreateReportModalComponent } from '@app/reporting/downloadable/components/create-report-modal/create-report-modal.component';
import { CreateReportModalOptions } from '@app/reporting/downloadable/models/downloadable-reports.model';
import { ModalService } from '@app/shared/services/modal.service';
import { Observable } from 'rxjs';

@Injectable()
export class DownloadableReportsModalsService {
  constructor(private modalService: ModalService) {}

  /**
   * Opens modal to create new downloadable report
   */
  public openCreateReportModal(
    options: CreateReportModalOptions
  ): Observable<unknown> {
    return this.modalService.show<void>(CreateReportModalComponent, {
      inputs: {
        modalOptions: options,
      },
    });
  }
}
